import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Nav';
import Hero from './components/Hero';
import { TimelineVerein } from './components/Timeline';
import Calendar from './components/Calendar';
import Gallery from './components/Gallery';
import Membership from './components/Membership';
import YearGallery from './components/YearGallery';
import Contact from './components/Contact';
import Vorstand from './components/Vorstand';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import PageNotFound from './components/PageNotFound';

const App = () => {
  return (
    <Router>
      <div >
        <Navbar />
        
        <main>
          <Routes>
            <Route path="" element={<Hero />} />
            <Route path="/vereinsgeschichte" element={<TimelineVerein />} />
            <Route path="/vorstand" element={<Vorstand />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/veranstaltungsplan" element={<Calendar />} />
            <Route path="/fotogalerie" element={<Gallery />} />
            <Route path="/mitgliedschaft" element={<Membership />} />
            <Route path="/fotogalerie/:jahr" element={<YearGallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/my-impressum" element={<Impressum />} />
            <Route path="/my-datenschutz" element={<Datenschutz />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
